import { frontendURL } from '../../../helper/URLHelper';
import OperationsDashboard from './OperationsDashboard.vue';

const PERMISSIONS = [
  'administrator',
  'agent',
  'custom_role',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/dashboard'),
      name: 'dashboard',
      meta: {
        permissions: PERMISSIONS,
      },
      component: OperationsDashboard,
    },
    {
      path: frontendURL('accounts/:accountId/overview'),
      name: 'operations_overview',
      meta: {
        permissions: PERMISSIONS,
      },
      component: OperationsDashboard,
    },
  ],
};
